import type { QueryClient } from '@tanstack/vue-query';
import {
  ELIGIBLE_VIEWERS_QUERY,
  GRANTED_ACCESS_QUERY,
  REVIEW_SHARING_INBOX_QUERY,
} from './queryKeys';

// Shared by every grant/deny/revoke mutation that can answer a request or
// change a viewer's categories, whether it's driven from this module's own
// supplier grant modal or from the action centre's inbox: both project the
// same review_sharing_grants rows onto the eligible-viewers list, the
// granted-access list, and the inbox, so an answer from either surface has to
// refresh all three or the other goes stale. One place so the two callers
// can't drift on which lists they invalidate.
export function invalidateGrantEffects(
  queryClient: QueryClient,
  { communityID, supplierID }: { communityID: string; supplierID: string },
) {
  void queryClient.invalidateQueries({
    queryKey: [ELIGIBLE_VIEWERS_QUERY, communityID, supplierID],
  });
  void queryClient.invalidateQueries({ queryKey: [GRANTED_ACCESS_QUERY, communityID] });
  void queryClient.invalidateQueries({ queryKey: [REVIEW_SHARING_INBOX_QUERY] });
}
